console.log('Article.js loaded!');

// Get token from config element (set in Liquid)
const articleConfig = document.getElementById('article-config');
const configToken = articleConfig ? JSON.parse(articleConfig.textContent).storefrontAccessToken : null;

const state = {
  shopName: "stspoc.myshopify.com",
  accessToken: configToken,
  noProductsMessage: "No products available for now",
  exceptionalTags: ["ctaquiz"],
  productItemBody: `
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        handle
        productType
        title
        tags
        priceRange {
          minVariantPrice {
            amount
          }
        }
        variants(first: 25) {
          edges {
            node {
              id
              title
              availableForSale
              quantityAvailable
              price {
                amount
              }
              compareAtPrice {
                amount
              }
              sku
            }
          }
        }
        images(first: 2) {
          edges {
            node {
              altText
              id
              originalSrc
            }
          }
        }
        featuredImage {
          altText
          id
          originalSrc
        }
      }
    } 
  `,
  products: [],
  elements: {}
}

const cacheElements = () => {
  state.elements = {
    sliderRoots: document.querySelectorAll(".article__product-slider--root, .productCard--loader"),
    bloggyArticle: document.querySelector('#bloggy--article')
  };
  
  console.log('cacheElements: Found slider roots:', state.elements.sliderRoots.length);
};

// Expose globally for use in Liquid template
window.cacheElements = cacheElements;

const renderProductCards = (product) => {
  // Check for ctaquiz in any form
  const hasCtaQuiz = (item) => {
    console.log('Checking item for ctaquiz:', item);
    
    if (typeof item === 'string') {
      console.log('Checking string:', item);
      return item.toLowerCase().includes('ctaquiz');
    }
    if (item.tags && Array.isArray(item.tags)) {
      console.log('Checking tags array:', item.tags);
      return item.tags.some(tag => tag.toLowerCase().includes('ctaquiz'));
    }
    if (item.dataset && item.dataset.tags) {
      console.log('Checking dataset tags:', item.dataset.tags);
      return item.dataset.tags.toLowerCase().includes('ctaquiz');
    }
    if (item.textContent) {
      console.log('Checking textContent:', item.textContent);
      return item.textContent.toLowerCase().includes('ctaquiz');
    }
    console.log('No ctaquiz found in item');
    return false;
  };

  // Check for the ctaquiz tag
  if (hasCtaQuiz(product)) {
    console.log('Found ctaquiz in product, creating button');
    const customerSkinType = localStorage.getItem("customerSkinType");
    let buttonText = customerSkinType ? "View My Skin Type Results" : "Take the Quiz";
    let buttonLink = customerSkinType ? "/pages/skin-type-results" : "/pages/skin-type-quiz";
    
    return `
      <a class="quizButton" href="${buttonLink}" style="background-color: lightgrey; color: black; text-align: center; padding: 15px; display: block; margin: auto;">
        ${buttonText}
      </a>
    `;
  }

  const variantId = product.variants && product.variants[0] && product.variants[0].id;

  //console.log('Product Name:', product.title);
  //console.log("Product availability:", product.available);
  //console.log("Variant available for sale:", product.variants[0].availableForSale);
  
  // Check for availability
  const isOutOfStock = !(product?.available && product?.variants[0].availableForSale);
  //console.log('Is Out of Stock:', isOutOfStock);  // Resulting stock status
  
  const buttonText = isOutOfStock ? "Out of Stock" : "Add to Cart";

  return `
    <div class="productCard--wrapper swiper-slide">
      <a href="/products/${product.handle}">
        <div class="productCard--img"><img src="${product?.images?.[0]?.originalSrc}" alt="${product.title}"></div>
        <div class="productCard--title">${product.title}</div>
      </a>
      <div class="productCard--details">
        <div class="productCard--price">$${Number(product.price).toFixed(2)}</div>
        <button class="addToCart" data-product-id="${product.id}" ${variantId ? `data-variant-id="${variantId}"` : ''} ${isOutOfStock ? "disabled" : ""}>${buttonText}</button>
      </div>
    </div>
  `;
}

const addToCartClickHandler = async (event) => {
  event.preventDefault();

  const productId = event.target.getAttribute('data-product-id');
  const variantId = event.target.getAttribute('data-variant-id');

  // Create the formData structure
  let formData = {};

  if (variantId) { // If variant ID is available
    formData = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };
  } else if (productId) { // If only product ID is available
    formData = {
      items: [{
        id: productId,
        quantity: 1
      }]
    };
  } else {
    console.error("No product or variant ID provided");
    return;
  }

  try {
      const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      });

      const data = await response.json();
      
      // Check if any of the items are sold out
      if (data.status === 422) {
          event.target.insertAdjacentHTML('afterend', `<span class="product__error">${data.description}</span>`);
          event.target.disabled = true;
          return console.error('Error occurred while adding product to cart:', data.description);
      }

      // Open cart drawer with variantId or productId (whichever is available)
      const idToOpenWith = variantId ? variantId : productId;
      openCartWithVariantId(idToOpenWith);

  } catch (error) {
      console.error('Error occurred while adding product to cart:', error);
  }
};

const drawer = document.querySelector('[data-drawer="drawer-cart"]');

const openCartWithVariantId = (id) => {
  drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
    detail: {
      variant: id,
      reinit: true
    },
    bubbles: true
  }));
};

// Listen for clicks on the document
document.addEventListener('click', async (e) => {
  if (e.target.classList.contains('addToCart')) {
    await addToCartClickHandler(e);
  }
});

const parseGraphQlId = (id) => {
  try {
    const parsedId = atob(id).split('/');
    return +parsedId[parsedId.length - 1];
  } catch (error) {
    const parsedId = id.split('/');
    return +parsedId[parsedId.length - 1]
  }
};

const handleNoProducts = (element) => {
  element.classList.add('no-products');
  element.innerHTML = "";
};

const showNoProductsMessage = (element, message) => {
  element.classList.add('show-message');
  element.innerHTML = message;
};

const restructureStorefrontProducts = (products) => {
  const restructuredProducts = products.map((product) => {
      const notAvailable = product.node.variants.edges.every(
      ({ node }) => (!node.quantityAvailable),
      );
      const productObj = {
      id: parseGraphQlId(product.node.id),
      available: !notAvailable,
      handle: product.node.handle,
      productType: product.node.productType,
      title: product.node.title,
      tags: product.node.tags,
      images: product.node.images.edges.map(({ node }) => ({ ...node })),
      featuredImage: product.node.featuredImage,
      price: product.node.priceRange.minVariantPrice.amount,
      compareAtPrice: product.node.variants.edges[0].node.compareAtPrice,
      options: product.node.options,
      vendor: product.node.vendor,
      variants: product.node.variants.edges.map(({ node }) => ({
          ...node,
          id: parseGraphQlId(node.id),
          options: node.title.split(' / '),
        })),
      };

      return productObj;
  })

  return restructuredProducts;
};

const fetchProductsByTag = async (
  shopName,
  accessToken,
  productItemBody,
  productBase,
  tag,
  quantity
) => {
  const exludeIDs = productBase.map(product => `-id:${product.id}`).join(' AND ')
  const exludeQuery = exludeIDs ? ` AND ${exludeIDs}` : ''
  const query = `query {
    products(first: ${quantity}, query: "${tag}${exludeQuery}") {
      ${productItemBody}
    }
  }`;
  //console.log("Fetching products with query:", query);
  try {
    const response = await fetch(`https://${shopName}/api/2023-04/graphql.json`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
      },
      body: JSON.stringify({ query }),
    });
    const { data } = await response.json();
    //console.log("Fetched products:", data.products.edges);
    const products = restructureStorefrontProducts(data.products.edges);
    return products
  } catch (error) {
    console.error("Error fetching products:", error);
  }
};

const getSliderQuantityAndTag = (element) => {
  let tagsFromEl = element.dataset.tags;
  // if(tagsFromEl.includes("ctaquiz")) {
  //   tagsFromEl = tagsFromEl + " | show_message=true";
  // }
  const splittedTags = tagsFromEl?.split("|");
  let [tags, message] = splittedTags;
  tags = tags?.split(',') || [];
  let quantity = Math.round(10 / tags.length);
  if (parseInt(tags[tags.length - 1])) {
    quantity = Math.round(tags.pop() / tags.length);
  }
  return {tags, message, quantity}
}

const renderSliders = async () => {
  if (!window.productSlider || !window.productSlider.slidesPerView) {
    console.warn('renderSliders: productSlider config not found, skipping');
    return;
  }
  
  const { desktop, mobile, mobileSmall } = window.productSlider.slidesPerView;
 
  for (const element of state.elements.sliderRoots) {
    // Handle product card loaders specifically
    if (element.classList.contains('productCard--loader')) {
      const parentElement = element.closest('.article__product-slider--root');
      if (!parentElement || !parentElement.dataset.tags) continue;
      
      // Clear existing loaders
      while (element.nextElementSibling && element.nextElementSibling.classList.contains('productCard--loader')) {
        element.nextElementSibling.remove();
      }
      
      // Process the parent element instead
      element = parentElement;
    }
    
    // Continue with existing slider logic
    let products = [];

    // Check for ctaquiz in any form
    const hasCtaQuiz = (item) => {
      console.log('Checking item for ctaquiz:', item);
      
      if (typeof item === 'string') {
        console.log('Checking string:', item);
        return item.toLowerCase().includes('ctaquiz');
      }
      if (item.tags && Array.isArray(item.tags)) {
        console.log('Checking tags array:', item.tags);
        return item.tags.some(tag => tag.toLowerCase().includes('ctaquiz'));
      }
      if (item.dataset && item.dataset.tags) {
        console.log('Checking dataset tags:', item.dataset.tags);
        return item.dataset.tags.toLowerCase().includes('ctaquiz');
      }
      if (item.textContent) {
        console.log('Checking textContent:', item.textContent);
        return item.textContent.toLowerCase().includes('ctaquiz');
      }
      console.log('No ctaquiz found in item');
      return false;
    };

    // Check for ctaquiz
    if (hasCtaQuiz(element)) {
      console.log('Found ctaquiz in element, creating button');
      const customerSkinType = localStorage.getItem("customerSkinType");
      let buttonText = customerSkinType ? "View My Skin Type Results" : "Take the Quiz";
      let buttonLink = customerSkinType ? "/pages/skin-type-results" : "/pages/skin-type-quiz";

      element.innerHTML = `
        <a href="${buttonLink}" class="quizButton" style="background-color: lightgrey; color: black; text-align: center; padding: 15px; display: block; margin: auto;">${buttonText}</a>
      `;
      continue; // Skip the rest of the loop iteration
    }
 
    // Identify SKU vs. tags by checking for a "-"
    const isSKU = element.dataset.tags && element.dataset.tags.includes("-");

    if (isSKU) {
      // Handle SKU data
      const skus = parseSKUs(element.dataset.tags);
      const { tags, quantity } = getSliderQuantityAndTag(element);
      for (const sku of skus) {
        const skuProducts = await fetchVariantBySKU(
          state.shopName,
          state.accessToken,
          state.productItemBody,
          products,
          sku,
          quantity
        );
        products.push(...skuProducts);
        state.products = products;
      }
      
    
    } else {
       // Handle tag data if not an SKU
       const { tags, quantity } = getSliderQuantityAndTag(element);
       if (!tags.length) continue;

       for (const tag of tags) {
         const tagProducts = await fetchProductsByTag(
           state.shopName, 
           state.accessToken, 
           state.productItemBody, 
           products, 
           tag, 
           quantity
         );
         products.push(...tagProducts);
         state.products = products;
       }
     }
 
     const { message } = getSliderQuantityAndTag(element);
     // Handle no products scenario
     if (!products.length) {
      //console.log("No products found for element:", element);
       if(message) {
         showNoProductsMessage(element, state.noProductsMessage)
       }else {
         handleNoProducts(element);
       }
       continue;
     }
 
     // Render products
     const renderedProducts = products.map(product => renderProductCards(product));
     //console.log("Rendering products for element:", element);
     element.innerHTML = `
     <!-- Slider main container -->
     <div class="swiper">
       <!-- Additional required wrapper -->
       <div class="swiper-wrapper">
         <!-- Slides -->
         ${desktop < products.length ? renderedProducts.join(' ').repeat(3) : renderedProducts.join(' ')}
       </div>
       <!-- If we need navigation buttons -->
       <div class="swiper-button-prev"></div>
       <div class="swiper-button-next"></div>
     </div>
     `;

     const swiperWrapper = element.querySelector('.swiper');

     const productSlider = new Swiper(swiperWrapper,
       {
         breakpoints: {
           769: {
             slidesPerView: desktop,
           },
           400: {
             slidesPerView: mobile,
           },
         },
         spaceBetween: 5,
         slidesPerView: mobileSmall,
         loop: true,
         centeredSlides: desktop < products.length ? true : false,
         resistance: false,
         on: {
           afterInit: () => {
             element.classList.add('rendered');
           }
         },
         navigation: {
           nextEl: '.swiper-button-next',
           prevEl: '.swiper-button-prev',
         },
       }
     );
   }
 };

// Expose globally for use in Liquid template
window.renderSliders = renderSliders;

 const parseSKUs = (tagsString) => {
  return tagsString.split(',').map(sku => sku.trim());
};

const fetchVariantBySKU = async (
  shopName,
  accessToken,
  productItemBody,
  productBase,
  sku,
  quantity
) => {
  const excludeIDs = productBase.map(product => `-id:${product.id}`).join(' AND ');
  const excludeQuery = excludeIDs ? ` AND ${excludeIDs}` : '';
  const query = `query {
    products(first: ${quantity}, query: "sku:${sku}${excludeQuery}") {
      ${productItemBody}
    }
  }`;
  //console.log("Fetching products with query:", query);
  try {
    const response = await fetch(`https://${shopName}/api/2023-04/graphql.json`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
      },
      body: JSON.stringify({ query }),
    });
    const { data } = await response.json();
    //console.log("Fetched products:", data.products.edges);
    const products = restructureStorefrontProducts(data.products.edges);
    return products;
  } catch (error) {
    console.error("Error fetching products:", error);
  }
};

const attachAddToCartEventListeners = () => {
  const addToCartButtons = document.querySelectorAll('.addToCart');
  addToCartButtons.forEach(button => {
      button.addEventListener('click', addToCartClickHandler);
  });
};

// Bracketed command processing is now handled in main-bloggle-article.liquid
// This function is kept for potential future use but currently does nothing
const initBloggleProducts = () => {
  // Processing moved to Liquid template to avoid conflicts with Bloggle CMS sliders
  console.log('initBloggleProducts: Bracketed commands are processed in Liquid template');
};

// Update the initialization code
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM Content Loaded - initializing...');
    initBloggleProducts(); // Process bracketed commands first to create inline sliders
    cacheElements(); // Then cache all elements including newly created sliders
    renderSliders().then(() => {
      console.log('Sliders rendered');
      attachAddToCartEventListeners();
    });
  });
} else {
  console.log('DOM already loaded - initializing...');
  initBloggleProducts(); // Process bracketed commands first to create inline sliders
  cacheElements(); // Then cache all elements including newly created sliders
  renderSliders().then(() => {
    console.log('Sliders rendered');
    attachAddToCartEventListeners();
  });
}

// Add these styles
const styles = `
  .bggle_product-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 15px;
  }
  
  .bggle_button-link {
    display: flex;
    flex-direction: column;
    height: 100%;
    text-decoration: none;
    color: inherit;
  }
  
  .bloggle_product--img {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
  
  .bloggle_product--infos {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  
  .fd--row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  
  .jc--center {
    justify-content: center;
  }
  
  .m--auto {
    margin: 10px auto;
  }
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.textContent = styles;
document.head.appendChild(styleSheet);
